import { ColorSystemPositive1, Spacing4 } from 'autogen/design-tokens/tokens';
import type { DiscountInfoViewModel } from 'autogen/swagger/all';
import { Typography } from 'components/generic/typography';
import WithIcon from 'components/hoc/withIcon/WithIcon';
import Icon from 'components/Icon';
import Flex from 'components/Layout/components/Flex';

export default function MiniBasketDiscountInfo({
    model: { visibleTriggeredDiscountTexts }
}: {
    model: DiscountInfoViewModel;
}) {
    if (!visibleTriggeredDiscountTexts.length) return null;

    const discountsTexts = visibleTriggeredDiscountTexts.filter(
        (visibleTriggeredDiscountText) => visibleTriggeredDiscountText.type === 'Discount'
    );

    return (
        <Flex.Column alignItems="start" gap={Spacing4}>
            {discountsTexts.map((discountText, index) =>
                discountText.showCheckmark ? (
                    <WithIcon icon={<Icon type="Checkmark" size={16} fill={ColorSystemPositive1} />} key={index}>
                        <Typography.Body as="span" size="S" strong>
                            {discountText.text}
                        </Typography.Body>
                    </WithIcon>
                ) : (
                    <Typography.Body as="span" size="S" strong key={index}>
                        {discountText.text}
                    </Typography.Body>
                )
            )}
        </Flex.Column>
    );
}
